import { render, staticRenderFns } from "./StandardTemplateBidPreview.vue?vue&type=template&id=24fbe52a&scoped=true&"
import script from "./StandardTemplateBidPreview.vue?vue&type=script&lang=js&"
export * from "./StandardTemplateBidPreview.vue?vue&type=script&lang=js&"
import style0 from "./StandardTemplateBidPreview.vue?vue&type=style&index=0&id=24fbe52a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fbe52a",
  null
  
)

export default component.exports